var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4752 14C5.92831 14 2.53225 11.0177 0.290551 7.92157C-0.0968503 7.38647 -0.0968503 6.60972 0.290551 6.07466C0.854166 5.2962 2.0353 3.79434 3.61309 2.48178C7.5871 -0.82407 11.3556 -0.830447 15.3373 2.48178C17.1909 4.02373 18.6598 6.04574 18.6598 6.07466C19.0472 6.60972 19.0472 7.38647 18.6598 7.92153C16.4185 11.0173 13.0229 14 9.4752 14ZM9.4752 1.32993C5.54597 1.32993 2.13992 5.61237 1.18964 6.92489C1.15893 6.96732 1.15893 7.02892 1.18964 7.07134C2.13996 8.38386 5.54597 12.6663 9.4752 12.6663C13.4044 12.6663 16.8105 8.38386 17.7608 7.07134C17.8162 6.99478 17.7571 6.92489 17.7608 6.92489C16.8104 5.61237 13.4044 1.32993 9.4752 1.32993Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4752 11.666C7.22303 11.666 5.39077 9.57202 5.39077 6.99812C5.39077 4.42422 7.22303 2.3302 9.4752 2.3302C11.7274 2.3302 13.5596 4.42422 13.5596 6.99812C13.5596 9.57202 11.7274 11.666 9.4752 11.666ZM9.4752 3.66389C7.86651 3.66389 6.55775 5.15963 6.55775 6.99812C6.55775 8.83662 7.86651 10.3324 9.4752 10.3324C11.0839 10.3324 12.3926 8.83662 12.3926 6.99812C12.3926 5.15963 11.0839 3.66389 9.4752 3.66389Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.37d49c7a1af90597a3fad10689dd9b6a.svg";
export { ForwardRef as ReactComponent };